import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simple-api-list',
  templateUrl: './simple-api-list.component.html',
  styleUrls: ['./simple-api-list.component.scss']
})
export class SimpleApiListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
